import { useMatches } from 'react-router'

import { useQueryParams } from '@/hooks/use-query-params'

export function useRouteProjectId() {
  const matches = useMatches()
  const projectIdFromPath = matches[matches.length - 1]?.params.projectId

  const { getQueryParams } = useQueryParams()
  const { projectId: projectIdFromQuery } = getQueryParams()

  return projectIdFromPath || projectIdFromQuery
}
